import { RootState } from '../../store';

export const getAppActiveStep = (state: RootState) => state.appStepperDetails.activeStep;

export const getAppBackAction = (state: RootState) => state.appStepperDetails.backAction;

export const getAppType = (state: RootState) => state.appStepperDetails.appType;

export const getSelectedProviders = (state: RootState) =>
  state.appStepperDetails.selectedProviders;

export const getAppStepperDetails = (state: RootState) => state.appStepperDetails;
